import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from '../../Services/language.service';

@Component({
  selector: 'app-page-languages',
  templateUrl: './page-languages.component.html',
  styleUrl: './page-languages.component.scss',
})
export class PageLanguagesComponent {
  router = inject(Router);
  LanguageService = inject(LanguageService);

  redirectTr() {
    this.router.navigate(['/categories']);
  }
  redirectEn() {
    this.router.navigate(['/categories']);
  }
  redirectAr() {
    this.router.navigate(['/categories']);
  }

  langaugeService = inject(LanguageService);

  onTurkish() {
    this.langaugeService.setLanguage('Tr');
    this.router.navigate(['/ordertype']);
  }

  onArabic() {
    this.langaugeService.setLanguage('Ar');
    this.router.navigate(['/ordertype']);
  }

  onEnglish() {
    this.langaugeService.setLanguage('En');
    this.router.navigate(['/ordertype']);
  }

  onWeb() {
    window.open('https://aradagroup.info', '_blank');
  }
}
